import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class GroupService extends BaseService{
	constructor() {
		super('/Group');
	}

	public getAllByFilter(filter: GroupFilter) {
		return super.getAllByFilterBase(filter);
	}

	public deleteList(list: number[]) {
		return this.deleteListWithResourceName(list, 'delete-list')
	}
}

export class GroupFilter extends BaseFilter{
	constructor(idUser?: number | null, idRole?: number | null, idTenant?: number | null, objectType?: string | null) {
		super();
		this._idRole = idRole;
		this._idUser = idUser;
		this._idTenant = idTenant;
		this._objectType = objectType;
	}
	private _idRole?: number | null;
	private _idTenant?: number | null;
	private _idUser?: number | null;
	private _objectType?: string | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idUser != null ? { IdUser: this._idUser } : {}),
			(this._idTenant != null ? { IdTenant: this._idTenant } : {}),
			(this._idRole != null ? { IdRole: this._idRole } : {}),
			(this._objectType != null ? { ObjectType: this._objectType } : {})
	
		);

		return data;
	};
}